// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: デモページの設定変更
const AdminOpsDemoUpdateApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_demo_update";

    const ExecAdminOpsDemoUpdateApi = async (pageName, title, reloadSec) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: { page_name: pageName, title: title, reload_sec: reloadSec } });
    };

    return ExecAdminOpsDemoUpdateApi;
};

export default AdminOpsDemoUpdateApi;
